import { useFileUpdate as useFileUpdateREST } from '@risksmart-app/components/src/file/useFileUpdate';

import { useIsFeatureFlagEnabled } from '../feature-flags/useIsFeatureFlagEnabled';
import { useFileUpdateTRPC } from './useFileUpdateTRPC';

/**
 * Flag-gated wrapper (RSP-6570) over the components V2 file-update hook
 * (`@risksmart-app/components/src/file/useFileUpdate` — REST upload + Apollo
 * `DeleteRelationFileById`) and its portal-local tRPC twin (presigned upload +
 * `files.deleteRelationFiles`). Same `{ updateFiles, error }` return on both
 * paths, so the questionnaire page's file-save flow is unchanged. Consumers
 * import THIS, never the `*TRPC` variant.
 */
export const useFileUpdate = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const rest = useFileUpdateREST();
  const trpc = useFileUpdateTRPC();

  return trpcEnabled ? trpc : rest;
};
